import { combineReducers } from 'redux';
import unionBy from 'lodash/unionBy';
import { REQUEST_VARIATIONS, RECEIVE_VARIATIONS } from './actionTypes';

const items = (state = [], action) => {
    switch (action.type) {
        case REQUEST_VARIATIONS:
            return state;
        case RECEIVE_VARIATIONS:
            return unionBy(action.variations, state, 'id');
        default:
            return state;
    }
};

const isFetching = (state = 0, action) => {
    switch (action.type) {
        case REQUEST_VARIATIONS:
            return 1;
        case RECEIVE_VARIATIONS:
            return 0;
        default:
            return state;
    }
};

export const variationsReducer = combineReducers({ items, isFetching });
